import React, { useEffect, useState } from 'react';
// import '../assets/css/dashboard.css';
import { Container, Card, Row, Col, Alert, Button, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import DashboardLayout from '../layouts/DashboardLayout'
import config from '../config';
import ChangeContact from '../components/ChangeContact';
import { set } from 'lodash';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Layout from '../layouts/Layout';
import ClarityLogo from '../assets/images/clarity-logo.png';


function Dashboard() {
  const [username, setUsername] = useState(sessionStorage.getItem('username'));
  const [decodedToken, setDecodedToken] = useState(sessionStorage.getItem('decodedToken'));
  const [bearerToken, setBearerToken] = useState(sessionStorage.getItem('bearerToken'));
  const [cases, setCases] = React.useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCaseId, setSelectedCaseId] = useState(null);
  const [selectedCompanyName, setCompanyName] = useState(null);
  const [selectedCaseType, setCaseType] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchCases();
  }, []); // Dependency on bearerToken

  useEffect(() => {
    if (!username) {
      setError('Access Denied: You must be authenticated to view the homepage.');
    }
  }, [username]);

  const fetchCases = async () => {
    if (!bearerToken) {
      setError('No token available. Please log in again.');
      setLoading(false);
      return;
    }

    try {
      setLoading(true); // Start loading before the request
      console.log(bearerToken)
      const response = await axios.get(`${config.API_URL}/RenewalCases/Auth/${username}`);
      setCases(response.data);
    } catch (error) {
      console.error('Error fetching cases:', error);
      setError('Failed to fetch cases. Please try again later.');
    } finally {
      setLoading(false); // Set loading to false after request completion
    }
  };



  // const handleNavigate = (company) => {
  //   if (company.caseType === "COBRA") {
  //     navigate(`/Cobra/${company.caseId}`, { state: { company } });
  //   } else {
  //     navigate(`/EmployeeBenefits/${company.caseId}`, { state: { company } });
  //   }

  // };

  const handleNavigate = (company) => {
    let targetUrl = "";
 
    if (company.caseStatus === "Form Submission") {
      targetUrl =
        company.caseType === "COBRA"
          ? `/Cobra/${company.caseId}?showPopup=true`
          : `/EmployeeBenefits/${company.caseId}?showPopup=true`;
    } else {
      targetUrl =
        company.caseType === "COBRA"
          ? `/Cobra/${company.caseId}`
          : `/EmployeeBenefits/${company.caseId}`;
    }
 
    // Navigate to the target URL
    navigate(targetUrl, { state: { company } });
  };


  const handleOpenModal = (company) => {

    setSelectedCaseId(company?.caseId);
    setCompanyName(company?.employerName)
    setCaseType(company?.caseType)
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  if (!username) return (<Layout>
    <div className="confirmation-container mt-5">
      <Card className="confirmation-card shadow-lg p-3 mb-5 bg-white rounded">
        <div className="text-center mb-4">
          <Image src={ClarityLogo} alt="Company Logo" className="confirmation-logo" />
        </div>

        <Alert variant="danger" className="text-center">Please login from the portal</Alert>



      </Card>
    </div>
  </Layout>);

  return (
    <DashboardLayout>
      <div className="admin">

        <div className=" main-content home-main-content ">
          <div className=" page-content ">
            <div className=" container-fluid home-container ">
              {/* <Container className="mt-5">
      <Row>
        <Col md={{ span: 6, offset: 3 }}>
          <h1 className="text-center">Home Page</h1>
          {error && <Alert variant="danger text-center my-5">{error}</Alert>}
          {username ? (
            <>
              <p className="text-center">Welcome, <strong>{username}</strong>!</p>  
              <div className="d-flex justify-content-center">
                <pre>{decodedToken.first_name}</pre>
              </div>
              <div className="d-flex justify-content-center">
                <Button variant="primary" >Logout</Button>
              </div>
            </>
          ) : (
            <p className="text-center text-info">Please login to continue.</p>
          )}
        </Col>
      </Row>
    </Container> */}
              <div className="row">
                <div className="col-lg-12">
                  <div className=" card ">
                    <div className=" card-body ">
                      <h5 className=" card-title mb-4 ">Renew Your Clarity Benefits</h5>
                      <div className="row">
                        <div className="col-lg-12">


                          <div className="table-responsive ">
                            <table
                              className="table table-hover table-centered table-nowrap mb-0 "
                              style={{ overflowY: 'auto' }}
                            >
                              <thead>
                                <tr>
                                <th>Bencode</th>
                                  <th>Client Name</th>
                                  <th>Renewal Date</th>
                                  <th>Notification Date</th>
                                  <th>Products</th>
                                  <th >Status</th>
                                  {/* <th>Progress</th> */}
                                  <th >Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {cases
                                  .sort((a, b) => a.employerName.localeCompare(b.employerName))
                                  .map((company, index) => (
                                    <tr key={company.id || index}>
                                      <td>{company.bencode}</td>
                                      <td>{company.employerName}</td>
                                      <td>{company.renewalDate}</td>
                                      <td></td>
                                      <td>{company.caseType}</td>
                                      <td>
                                        <span className="badge bg-primary rounded-0 progress-status">
                                          {company.caseStatus}
                                        </span>
                                      </td>
                                      <td>
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={
                                            <Tooltip id="plan-rule-tooltip">
                                              Please click here to access the form
                                            </Tooltip>
                                          }
                                        >
                                          <button
                                            className="btn btn-primary resume-button custom-button"
                                            onClick={() => handleNavigate(company)}
                                          >
                                            Open
                                          </button>
                                        </OverlayTrigger>
                                        <button
                                          className="btn btn-primary invite-button custom-button"
                                          onClick={() => handleOpenModal(company)}
                                        >
                                          Change contact
                                        </button>
                                      </td>
                                    </tr>
                                  ))}

                              </tbody>

                            </table>
                            {loading && (<Skeleton count={5} />)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && <ChangeContact caseId={selectedCaseId} onClose={handleCloseModal} action='change contact' companyName={selectedCompanyName} caseType={selectedCaseType} />}
    </DashboardLayout>
  );
}

export default Dashboard;
